"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CAMERA_DISCONNECTIVITY_MESSAGE = void 0;
var CAMERA_DISCONNECTIVITY_MESSAGE = exports.CAMERA_DISCONNECTIVITY_MESSAGE = 'Your camera was disconnected. Connect one in your settings to appear on camera again.';